import { useState, useEffect } from 'react';
import { IqueryDateList } from 'view/Layout/type';
import { Ioption } from 'tradevan-ui/type';
import { useForm } from 'react-hook-form';
import { addDays } from 'date-fns';

import { nameMaster } from '../../consts';
import { EnumMaster, EnumQueryDateSelect, QueryOrderForm } from '../../init';

/** 動態下拉選單將值整理製下拉選單
 * 設定開始日期、結束日期
 */
const useQueryDate = (
  queryDateList: IqueryDateList[],
  formReturn: ReturnType<typeof useForm<QueryOrderForm>>,
) => {
  const { setValue } = formReturn;
  const [queryDateOpTrs, setQueryDateOpTrs] = useState<Ioption[]>([]);

  const handleQueryDateOptionChange = (optionValue: string) => {
    // console.log('handleQueryDateOptionChange optionValue', optionValue);
    if (optionValue !== '' && queryDateList) {
      const foundItem = queryDateList.find(
        (item) => item.optionId === optionValue,
      );
      const addBeginDays = foundItem
        ? foundItem[EnumQueryDateSelect.預設起始天數]
        : 0;
      const addEndDays = foundItem
        ? foundItem[EnumQueryDateSelect.預設結束天數]
        : 0;

      setValue(
        nameMaster(EnumMaster.queryDateBegin),
        addDays(new Date(), addBeginDays),
      );
      setValue(
        nameMaster(EnumMaster.queryDateEnd),
        addDays(new Date(), addEndDays),
      );
    }
  };

  useEffect(() => {
    if (queryDateList) {
      if (queryDateList.length > 0) {
        //  console.log('useEffect queryDateList', queryDateList);
        //  console.log('useEffect queryList', queryDateList.length);
        const queryDateOptions = queryDateList.map((item) => ({
          value: item.optionId,
          label: item.propertyName,
        }));
        setQueryDateOpTrs(queryDateOptions);
        setValue(
          nameMaster(EnumMaster.queryDateValue),
          queryDateOptions[0].value,
        );
        handleQueryDateOptionChange(queryDateOptions[0].value);
      }
    }
  }, [queryDateList]);

  return {
    queryDateOpTrs,
    handleQueryDateOptionChange,
  };
};

export default useQueryDate;
